import React from "react";
import clsx from 'clsx'

import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";

import { radioNoUID } from '../../../../../../constants'
import RichTextEditor from "../../../formElement/RichTextEditor";
import {renderQuestion} from "../../../../../../utils";
import InfoCard from "../../DynamicStep/components/InfoCard";

import styles from "../styles";

const SellsStep = props => {
  const {
    classes,
    onAnswerChange,
    questions,
    dataService
  } = props;

  const mainInformationProvidedCheckbox = questions.find(q => q.uid === 'main_information_provided[\'checkbox\']'),
      yearlyReportInformationProvidedCheckbox = questions.find(q => q.uid === 'yearly_report_information_provided[\'checkbox\']'),
      conflicts = questions.find(q => q.uid === 'conflicts'),
      conflictsDetails = questions.find(q => q.uid === 'conflicts_details');

  const handleConflictsCheckboxChange = (question, answer) => {
    if (answer == radioNoUID && conflictsDetails.error) {
      conflictsDetails.error = null
    }
    onAnswerChange(question, answer)
  };

  const handleConflictsDetailsChange = (answer) => {
    conflictsDetails.error = null;
    onAnswerChange(conflictsDetails.uid, answer)
  };

  return (
    <Grid container spacing={2} justify={"center"}>
      {!!mainInformationProvidedCheckbox && (
        <>
          {renderQuestion(mainInformationProvidedCheckbox, onAnswerChange, dataService)}
          {renderQuestion(yearlyReportInformationProvidedCheckbox, onAnswerChange, dataService)}
        </>
      )}

      {!!conflicts && (<>
        {renderQuestion(conflicts, handleConflictsCheckboxChange, dataService)}
        {(conflicts.answer === radioNoUID && !!conflicts.info_text) && (
          <Grid item xs={12}>
            <InfoCard
              uid={`${conflicts.uid}-info-card`}
              isNewDesign
              info_text={conflicts.info_text}
            />
          </Grid>
        )}
        <Grid item xs={12}>
          <RichTextEditor
            uid={conflictsDetails.uid}
            label={conflictsDetails.question_text}
            value={conflictsDetails.answer || ''}
            onChange={handleConflictsDetailsChange}
            rows={6}
            customClasses={{
              labelRoot: clsx(classes.inputLabelRoot, 'bold', dataService.isNewDesign && classes.subCategoryLabel)
            }}
            placeholder={conflictsDetails.config && conflictsDetails.config.placeholder}
            error={conflictsDetails.error}
          />
        </Grid>
      </>)}
    </Grid>
  );
};

export default withStyles(styles)(SellsStep);
